/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Keep the selected thumbnail in view in the shared UJack product template. */
(function () {
  var thumbnailObservers = new Map();

  function connectThumbnailStrip(scroller) {
    if (thumbnailObservers.has(scroller)) return;

    var scheduled = false;
    function centerSelected(animate) {
      if (!window.matchMedia('(min-width: 1008px)').matches) return;

      var selected = scroller.querySelector('.Product__SlideshowNavImage.is-selected');
      if (!selected) return;

      var stripRect = scroller.getBoundingClientRect();
      var selectedRect = selected.getBoundingClientRect();
      var offset = selectedRect.left + selectedRect.width / 2 - stripRect.left - stripRect.width / 2;
      var left = Math.max(0, Math.min(scroller.scrollWidth - scroller.clientWidth, scroller.scrollLeft + offset));
      if (Math.abs(left - scroller.scrollLeft) < 1) return;

      scroller.scrollTo({
        left: left,
        behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
      });
    }

    var observer = new MutationObserver(function (mutations) {
      if (scheduled || !mutations.some(function (mutation) {
        return mutation.target.classList.contains('Product__SlideshowNavImage');
      })) return;

      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        centerSelected(true);
      });
    });
    observer.observe(scroller, {subtree: true, attributes: true, attributeFilter: ['class']});
    thumbnailObservers.set(scroller, observer);
    centerSelected(false);
  }

  function connectAll(root) {
    root.querySelectorAll('.UjackProduct .Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller').forEach(connectThumbnailStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { connectAll(document); });
  } else {
    connectAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { connectAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.UjackProduct .Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller').forEach(function (scroller) {
      var observer = thumbnailObservers.get(scroller);
      if (observer) observer.disconnect();
      thumbnailObservers.delete(scroller);
    });
  });
})();
